import React from 'react';

export default function KYCPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          KYC (Know Your Customer) Policy
        </h1>
        <p className="text-gray-700 mb-8">
          Million2Trillion (M2T) operates under strict KYC guidelines to verify the identity of every professional operating inside the financial marketplace.
        </p>

        <h2 className="text-2xl font-bold text-blue-900 mt-8 mb-2">
          Purpose of KYC
        </h2>
        <p className="text-gray-700 mb-6">
          Our KYC policy ensures that only real, verified, and qualified professionals are allowed to participate, transact, sell, advise, educate, or publish content inside Million2Trillion. This builds the verified trust layer across the entire M2T ecosystem.
        </p>

        <h2 className="text-2xl font-bold text-blue-900 mt-8 mb-2">
          KYC Required For:
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All verified sellers, signal providers, educators, coaches, analysts, mentors, and advisors</li>
          <li>All financial contributors, investors, partners, and revenue earners</li>
          <li>All monetized or high-level account holders</li>
        </ul>

        <h2 className="text-2xl font-bold text-blue-900 mt-8 mb-2">
          KYC Documents Required:
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li> Government-issued Photo ID (Passport, National ID, Driver’s License)</li>
          <li> Proof of Address (Utility Bill, Bank Statement, Government Letter)</li>
          <li> Selfie with Document (Live Verification)</li>
          <li> Corporate Registration (for business entities)</li>
          <li> Tax Identification (where applicable)</li>
        </ul>

        <h2 className="text-2xl font-bold text-blue-900 mt-8 mb-2">
          Data Storage & Security
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All KYC data is encrypted, securely stored, and accessible only to authorized compliance personnel.</li>
          <li>Million2Trillion never sells or shares private identity data to any third party, except where legally required.</li>
        </ul>

        <h2 className="text-2xl font-bold text-blue-900 mt-8 mb-2">
          Failure to Submit KYC
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Accounts will remain restricted until full KYC is completed and verified.</li>
          <li>Failure to comply may lead to account suspension or permanent platform removal.</li>
        </ul>

        <h2 className="text-2xl font-bold text-blue-900 mt-8 mb-2">
          KYC Verification Timeline
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Normal verification: 24-72 business hours after complete document submission.</li>
          <li>Enhanced verification (for complex cases): May take longer if additional compliance review is required.</li>
        </ul>

        <p className="text-gray-700 mb-8">
          Million2Trillion maintains full compliance with international KYC regulations to build the world’s most trusted financial ecosystem.
        </p>



      </div>
    </div>
  );
}
